//const baseUrl = process.env.REACT_APP_SERVICES_URL + '/shippingLabel/buildLabel';

//import { WorkshopRequestDTO } from '../models/workshop-request';
import { IResult } from '../models/result-models';
import { apiGetPDF, apiPost } from './api-utils';
import { LabelRequestDTO, LabelResponseDTO } from '../models/shipping-label';

const baseUrl =
    process.env.REACT_APP_SERVICES_URL + '/shippingLabel/buildLabel';

export const submitLabelRequest = async (
    shippinglabelrequest: LabelRequestDTO
): Promise<IResult<LabelResponseDTO>> => {
    const result = await apiPost<LabelRequestDTO, LabelResponseDTO>(
        `${baseUrl}`,
        shippinglabelrequest
    );
    return result;
};

export const getShippingLabelPDF = async (url: string): Promise<Response> => {
    const result = await apiGetPDF(url);

    return result;
};
